import styled from "styled-components";
interface IValueProps {
  value: boolean;
}
export const SidebarContainer = styled.div<IValueProps>`
  z-index: 99;
  .sidebar-item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    padding-left: ${(props) => (props.value ? "27px" : "21px")};
    transition: all var(--ac-dur) var(--ac-ease);
    height: ${(props) => (props.value ? "auto" : "50px")};

    .iconActive {
      padding-left: 15px;
    }

    .unical-logo {
      width: 1200px !important;
      background-color: red;
    }

    svg {
      color: var(--ac-on-dark-muted);
      transition: all var(--ac-dur) var(--ac-ease);
    }

    color: var(--ac-on-dark-muted);
    font-size: 14px;
    font-weight: 400;
    &:hover {
      cursor: pointer !important;
      background-color: rgba(255, 255, 255, 0.06);
      color: var(--ac-on-dark);
    }
    &:hover svg {
      color: var(--ac-on-dark);
      transition: color var(--ac-dur) var(--ac-ease);
    }
  }

  .sidebar-item-parent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
    color: var(--ac-on-dark-muted);
    padding-left: ${(props) => (props.value ? "27px" : "21px")};
    font-size: 14px;
    font-weight: 400;
    /* margin-bottom: 0.5rem; */
    transition: all var(--ac-dur) var(--ac-ease);
    height: ${(props) => (props.value ? "auto" : "50px")};

    .boxsOfChild {
      display: flex;
      align-items: center;

      .sidebar_hovered_box {
        width: 400px;
        padding: 10px;
      }

      .iconActive {
        padding-left: 15px;
      }
      .boxOfTexts {
        margin-left: 10px;

        &.active {
          display: none;
        }
      }
    }

    .upAndDownIcon {
      margin-right: 10px;
    }

    svg {
      color: var(--ac-on-dark-muted);
      transition: all var(--ac-dur) var(--ac-ease);
    }

    &:hover {
      cursor: pointer !important;
      background-color: rgba(255, 255, 255, 0.06);
      color: var(--ac-on-dark);
    }
    &:hover svg {
      color: var(--ac-on-dark);
      transition: color var(--ac-dur) var(--ac-ease);
    }
  }

  .sideBar-active {
    cursor: pointer !important;
    position: relative;
    background-color: var(--ac-accent-weak);
    color: var(--ac-on-dark);

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background-color: var(--ac-accent);
    }

    svg {
      color: var(--ac-accent);
    }
  }
  position: relative;
  overflow: hidden;
  .MuiListItemIcon-root {
    min-width: ${(props) => (props.value ? "30px" : "70px")};
  }
  .MuiListItem-button {
    padding-left: 10px !important;

    a {
      color: var(--ac-on-dark-muted);
    }
    span {
      font-size: 14px;
      font-weight: 400;
      /* color: var(--ac-on-dark-muted); */
    }
    svg {
      color: var(--ac-on-dark-muted);
    }
    white-space: nowrap;
  }
  .sidebar-content {
    background-color: var(--ac-ink);
    width: 100%;
    left: 0;
    top: 0;
    height: 100vh;
    position: fixed;
    bottom: 0;
    border-right: 1px solid rgba(255, 255, 255, 0.06);
  }

  .sidebar-top {
    height: 116px;
    //     border-bottom: 1px solid #eaeaef;
    display: flex;
    align-items: center;
    padding-right: 6px;
    justify-content: center;
    gap: 12px;

    &.active {
      height: 150px;
    }
  }

  .sidebar-top-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 19px;
    width: ${(props) => (props.value ? "auto" : "100%")};
    padding-left: ${(props) => (props.value ? "24px" : "0")};

    .unical-logo {
      width: 160px;
    }

    &.active {
      flex-direction: column-reverse;
      gap: 8px;
    }

    .brandLogo {
      width: 176px;
      height: auto;
      display: block;
    }

    .logoFirst {
      width: 42px;
      height: auto;
    }
    .sidebar_arrow {
      cursor: pointer;
      transition: all var(--ac-dur) var(--ac-ease);

      &.active {
        transform: rotateY(180deg);
      }
    }
  }

  .sidebar-main {
    overflow-x: hidden;
    overflow-y: auto !important;
    height: calc(100vh - 116px);
    display: grid;
    grid-template-columns: 1fr;

    /* width */
    ::-webkit-scrollbar {
      width: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.18);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }

  .asosiy {
    margin-bottom: 10px;
    h3 {
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      color: var(--ac-on-dark-muted);
    }
  }

  .sidebar-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 48px;
    border-top: 1px solid #eaeaef;
    background-color: #fff;
    display: flex;
    justify-content: right;
    align-items: right;
    padding: 1rem;
  }
  .MuiTypography-root {
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    font-family: "SF Pro Display";
    font-style: normal;
  }
  .sidebar-bottom {
    li {
      svg {
        transition: all 0.4s ease;

        transform: ${(props) =>
          props.value ? "rotateZ(0)" : "rotateZ(180deg)"};
      }
    }
  }
`;

export const HoveredItems = styled.div`
  width: 175px;
  ul {
    /* margin-bottom: 5px; */
    &:nth-child(1) {
      margin-top: 5px;
    }
  }
  li {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    transition: all var(--ac-dur) var(--ac-ease);
    font-size: 12px;
    font-weight: 600;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    &.sideBarHovered-active {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    gap: 10px;
    height: 34px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    span {
      margin-top: 2px;
      img {
        width: 16px;
      }
    }
  }
`;
